import { newEnforcer } from 'casbin';
import { ApolloAdapter } from './adapter';
import { model } from './casbin-model';
import { TAP_SYSTEM_USER } from './constants';
export class PermissionChecker {
    constructor(_apolloClient, user, tenant, namespace) {
        this._apolloClient = _apolloClient;
        this.user = user;
        this.tenant = tenant;
        this.namespace = namespace;
    }
    static cleanseNamespace(namespace) {
        namespace = namespace.trim();
        if (namespace.endsWith(':')) {
            namespace = namespace.replace(/^(.*?)[:]+$/, '$1');
        }
        return namespace;
    }
    static concatNamespaceResource(namespace, resource) {
        return namespace ? `${namespace}:${resource}` : resource;
    }
    set user(user) {
        if (TAP_SYSTEM_USER === user) {
            throw new Error('The provided user value is not available for usage');
        }
        this._user = user;
    }
    get user() {
        return this._user;
    }
    set tenant(tenant) {
        this._tenant = tenant;
    }
    get tenant() {
        return this._tenant;
    }
    set namespace(namespace) {
        this._namespace = PermissionChecker.cleanseNamespace(namespace);
    }
    get namespace() {
        return this._namespace;
    }
    set adapter(adapter) {
        this._adapter = adapter;
    }
    get adapter() {
        return this._adapter;
    }
    set enforcer(enforcer) {
        this._enforcer = enforcer;
    }
    get enforcer() {
        return this._enforcer;
    }
    get apolloClient() {
        return this._apolloClient;
    }
    async initialize() {
        this.adapter = new ApolloAdapter(this.apolloClient, this.user, this.tenant);
        this.enforcer = await newEnforcer(model, this.adapter);
    }
    async reload() {
        this.isInitialized();
        await this.enforcer.loadPolicy();
    }
    checkPermission(resource, action) {
        this.isInitialized();
        const fullResourceName = PermissionChecker.concatNamespaceResource(PermissionChecker.cleanseNamespace(this.namespace), resource);
        return this.enforcer.enforceSync(this.user, this.tenant, fullResourceName, action);
    }
    async getRoles() {
        this.isInitialized();
        return await this.enforcer.getRolesForUser(this.user, this.tenant);
    }
    isInitialized() {
        if (!this.enforcer) {
            throw new Error('Class has to be initialized before usage');
        }
    }
    async reloadPolicy() {
        await this.enforcer.loadFilteredPolicy({
            user: this.user,
            tenant: this.tenant,
        });
    }
}
//# sourceMappingURL=checker.js.map